/**
 * @generated SignedSource<<845424bf85b66ff79b564f72fb8fa37e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyerProtectionBox_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerProtectionGuarantee_user">;
  readonly " $fragmentType": "PdpSharedBuyerProtectionBox_user";
};
export type PdpSharedBuyerProtectionBox_user$key = {
  readonly " $data"?: PdpSharedBuyerProtectionBox_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerProtectionBox_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyerProtectionBox_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtectionGuarantee_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "309a5d88d9cbfd4fb6998fb1610668bd";

export default node;
